import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

export const STORE_COUNTRIES = [
  MarketCountryCode.AT,
  MarketCountryCode.BE,
  MarketCountryCode.DE,
  MarketCountryCode.ES,
  MarketCountryCode.FI,
  MarketCountryCode.FR,
  MarketCountryCode.GR,
  MarketCountryCode.IT,
  MarketCountryCode.NL,
  MarketCountryCode.GB,
  MarketCountryCode.IE,
  MarketCountryCode.US,
  MarketCountryCode.PT,
  MarketCountryCode.GR,
  MarketCountryCode.SK,
  MarketCountryCode.AU,
]

// Countries where only the iOS App Store button is shown (no Android/Google Play)
export const APPLE_ONLY_COUNTRIES: MarketCountryCode[] = []

export const BASE_APP_STORE_URL =
  'https://apps.apple.com/us/app/back-market-buy-sell/id1458344336'
export const BASE_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.backmarket'
